import { ApiError, ErrorCode } from '@/types/types';
import axios, { AxiosError, HttpStatusCode, isAxiosError } from 'axios';
import LANGUAGES from '@/configs/languages';
import APP_CONFIG from '@/configs/appConfig';

const httpClient = axios.create({
	baseURL: import.meta.env.VITE_API_URL,
	headers: {
		Accept: 'application/json',
		'Content-type': 'application/json; charset=UTF-8',
		'Accept-Language': LANGUAGES[APP_CONFIG.DEFAULT_LANGUAGE].code,
	},
});

httpClient.interceptors.request.use((request) => {
	if (request.data instanceof FormData) request.headers.setContentType('');
	return request;
});

httpClient.interceptors.response.use(
	(response) => response,
	(error) => {
		if (isAxiosError<ApiError>(error)) {
			if (error.code === AxiosError.ECONNABORTED) throw error;
			if (error.status === HttpStatusCode.InternalServerError)
				throw {
					code: HttpStatusCode.InternalServerError,
					stack: ErrorCode.GENERIC,
				};

			const stack = error.response!.data.message[0];

			throw {
				status: error.response!.data.status,
				stack,
			};
		}

		throw {
			code: HttpStatusCode.InternalServerError,
			stack: ErrorCode.GENERIC,
		};
	}
);

export default httpClient;
